module.exports = __webpack_public_path__ + "img/emoji_102.e8ce7cfb.png";